import { render, staticRenderFns } from "./hzserver.vue?vue&type=template&id=35293882&scoped=true"
import script from "./hzserver.vue?vue&type=script&lang=js"
export * from "./hzserver.vue?vue&type=script&lang=js"
import style0 from "./hzserver.vue?vue&type=style&index=0&id=35293882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35293882",
  null
  
)

export default component.exports